import { Types } from 'mongoose';
import * as c from './relationship-to-center.const';

export const REFERRAL_SOURCE = {...c.REFERRAL_SOURCE, _id: new Types.ObjectId(c.REFERRAL_SOURCE._id)};
export const REFERRED_TO = {...c.REFERRED_TO, _id: new Types.ObjectId(c.REFERRED_TO._id)};
export const REPORTING_ORG_AGENCY = {...c.REPORTING_ORG_AGENCY, _id: new Types.ObjectId(c.REPORTING_ORG_AGENCY._id)};
export const AGENCY_SERVED = {...c.AGENCY_SERVED, _id: new Types.ObjectId(c.AGENCY_SERVED._id)};
// export const CLEARANCE_REQUIRED = {...c.CLEARANCE_REQUIRED, _id: new Types.ObjectId(c.CLEARANCE_REQUIRED._id)};
export const EDUCATION_PROVIDER = {...c.EDUCATION_PROVIDER, _id: new Types.ObjectId(c.EDUCATION_PROVIDER._id)};
export const PARTNER = {...c.PARTNER, _id: new Types.ObjectId(c.PARTNER._id)};
export const SPONSOR = {...c.SPONSOR, _id: new Types.ObjectId(c.SPONSOR._id)};
// export const ORGANIZER = {...c.ORGANIZER, _id: new Types.ObjectId(c.ORGANIZER._id)};
export const FUNDER = {...c.FUNDER, _id: new Types.ObjectId(c.FUNDER._id)};

export const RELATIONSHIP_TO_CENTER = {
    _id: new Types.ObjectId('507f1f77bcf86cd799439021'),
    type: 'Relationship(s) to Center',
    category: 'System',
    value: [
        REFERRAL_SOURCE,
        REFERRED_TO,
        REPORTING_ORG_AGENCY,
        AGENCY_SERVED,
        // CLEARANCE_REQUIRED,
        EDUCATION_PROVIDER,
        SPONSOR,
        PARTNER,
        // ORGANIZER,
        FUNDER,
    ],
};
